import { CommApiInstance } from "Utils/CommApiInstance";


const DpstOdrCrdtApi = async (
    gameSvcCd:string    ,
    pymtMthdCd:string   ,
    prdtKindCd:string   ,
    dpstPrdtCd:string   ,
    dpstPrdtCnt:number  ,
    dpstOdrMny:string   ,
    prdtPrc:string      ,
    pgCd:string,
    rcmnPrdtCd?: string
) => {
    return await CommApiInstance.post(`${"/pymt/"+gameSvcCd+"/dpst_odr/crt"}`, {
        apiBody: {
            pymtMthdCd : pymtMthdCd, 
            prdtKindCd : prdtKindCd,
            prdtCd : dpstPrdtCd,
            prdtCnt : dpstPrdtCnt, 
            odrAmt : dpstOdrMny,
            prdtPrc : prdtPrc,
            pgCd : pgCd,
            rcmnPrdtCd: rcmnPrdtCd,
        }
    })
    .then((Resp) => Resp.data);
}

export default DpstOdrCrdtApi;
